import { render, staticRenderFns } from "./DashboardUsersWidget.vue?vue&type=template&id=32772836&"
import script from "./DashboardUsersWidget.vue?vue&type=script&lang=js&"
export * from "./DashboardUsersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports